/* import __COLOCATED_TEMPLATE__ from './signup-category-selector.hbs'; */
import { computed } from '@ember/object';
import { A } from '@ember/array';
import Component from '@ember/component';

/** @type {Function} */
const noop = () => {};

/**
 * @param {VideoCategory} category
 * @returns {{ key: String, model: VideoCategory }}
 */
const mapCategoryToOption = (category) => ({
  key: category.get('label'),
  model: category,
});

export default Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {String} */
  label: '',

  /** @type {Ember.A<VideoCategory>} */
  options: A([]),

  /** @type {Ember.A<VideoCategory>} */
  selected: A([]),

  /** @type {Boolean} */
  disabled: false,

  /** @type {String} */
  internalValue: '',

  /** @type {Ember.A<Object>} */
  mappedCategories: computed('options.[]', function () {
    return this.get('options').map(mapCategoryToOption);
  }),

  /** @type {Ember.A<Object>} */
  filteredCategories: computed('internalValue', 'mappedCategories.[]', function () {
    const internalValue = this.get('internalValue');
    const mappedCategories = this.get('mappedCategories');

    if (!internalValue) {
      return mappedCategories;
    }

    return mappedCategories.filter(({ key }) => {
      const pattern = new RegExp(`(\\b${internalValue})`, 'ig');
      return pattern.test(key);
    });
  }),

  /** @type {Ember.A<Object>} */
  selectedCategories: computed('selected.[]', function () {
    return this.get('selected').map(mapCategoryToOption);
  }),

  actions: {
    handleBlur() {
      this.set('internalValue', '');
      this.get('onblur')?.();
    },

    /**
     * @param {String} value
     */
    handleInput(value) {
      this.set('internalValue', value);
    },

    /**
     * @param {Object} object
     */
    handleAdded({ model }) {
      this.set('internalValue', '');

      const selected = this.get('selected');

      const isValid = selected.findIndex((id) => model.get('id') === id) === -1;

      if (isValid) {
        this.get('onadded')?.(model);
      }
    },

    /**
     * @param {Object} object
     */
    handleRemoved({ model }) {
      this.get('onremoved')?.(model);
    },
  },
});
